module.exports = __webpack_public_path__ + "media/images/embolt-14e974ddced990b6659934294afca865.png";